interface UseDebugArgs {
  debugMode?: boolean
}

export const useDebug = ({ debugMode }: UseDebugArgs) => {
  return (lambda: () => void) => {
    if (debugMode) lambda()
  }
}
